<template>
  <div :class="portfolios.length > 0 ? 'tw-text-[#1F2229] tw-bg-[#FCFCFD] tw-border tw-border-solid tw-border-[#DFE2E7] tw-rounded-lg tw-p-3' : ''">
    <div
      v-if="portfolios.length === 0"
      class="tw-text-[#B3B9C6] tw-text-sm"
    >
      {{ placeholder }}
    </div>
    <div
      v-else
      class="tw-flex tw-flex-col tw-gap-3"
    >
      <div class="tw-text-gray-400">
        <span
          v-if="portfolioType === 'portfolio'"
          class="tw-text-[#1F2229] tw-font-bold"
        >
          {{ portfolios.length }}
        </span>
        {{ portfolioCountMessage }}
      </div>
      <div
        v-for="portfolio in portfolios"
        :key="portfolio.external_id"
      >
        <PortfolioButton
          :portfolio="portfolio"
          :showTaxabilityDropdown="showTaxabilityDropdown"
          @remove="handleRemove(portfolio)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PortfolioButton from './PortfolioButton.vue';

export default {
  name: 'SelectedPortfolios',
  components: { PortfolioButton },
  props: {
    portfolioType: { type: String, default: 'portfolio' },
    portfolios: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'No portfolios selected' },
    showTaxabilityDropdown: { type: Boolean, default: false }, 
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    portfolioCountMessage() {
      const n = this.portfolios.length;
      if (n === 0) return this.placeholder || `No ${this.portfolioType}s selected`;

      if (this.portfolioType === 'benchmark') {
        return 'Benchmark Portfolio selected';
      }

      return `portfolio${n > 1 ? 's' : ''} selected`;
    },
  },
  methods: {
    handleRemove(portfolio) {
      console.log('active notifications', portfolio)
      this.$emit('remove', portfolio);
    },
  },
};
</script>
